import React, { memo } from 'react';
import { AntepostItem } from 'components/scommesseTipo/scommesseTipoAntepost/AntepostItem';
import { ScommesseTipoProps } from 'components/scommesseTipo/types';
import styles from './ScommesseTipoAntepost.module.scss';
import { useInfoAggiuntivaBilanciata } from 'features/sport/hooks';

export const Scommessa = memo(function Scommessa({ scommessaKey, gtagAction }: ScommesseTipoProps) {
  const info = useInfoAggiuntivaBilanciata(scommessaKey);
  const { nextInfoAgg } = info ?? {};

  return (
    <div className={styles.container} data-testid={`ScommesseTipoAntepost: ${scommessaKey}`}>
      {nextInfoAgg?.map((infoAggKey) => (
        <AntepostItem
          key={infoAggKey}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggKey}
          gtagAction={gtagAction}
        />
      ))}
    </div>
  );
});